// extracted by mini-css-extract-plugin
export default {"avatar":"style_avatar__Xoph3","ff-primary":"style_ff-primary__1VxHv"};